module.exports = __webpack_public_path__ + "img/IMG_7111.90ae081a.webp";